import React, {useState} from 'react'
import KategorijaRepromaterijalaDropdown from '../KategorijaRepromaterijalaDropdown/KategorijaRepromaterijalaDropdown'
import KodBojeRepromaterijalaDropdown from '../KodBojeRepromaterijalaDropdown/KodBojeRepromaterijalaDropdown'
import VrstaMaterijalaDropdown from '../VrstaMaterijalaDropdown/VrstaMaterijalaDropdown'
import KvalitetMaterijalaDropdown from '../KvalitetMaterijalaDropdown/KvalitetMaterijalaDropdown'
import ProizvodjacPartnerDropdown from '../ProizvodjacPartnerDropdown/ProizvodjacPartnerDropdown'
import DobavljacPartnerDropdown from '../DobavljacPartnerDropdown/DobavljacPartnerDropdown'
import StatusRolneDropdown from '../StatusDropdown/StatusRolneDropdown'
import SkladisteRepromaterijalaDropdown from '../SkladisteRepromaterijalaDropdown/skladisteRepromaterijalaDropdown'
import LokacijeRepromaterijalaDropdown from '../LokacijeRepromaterijalaDropdown/LokacijeRepromaterijalaDropdown'
import {useFormik} from 'formik'
import BojaDropdown from '../BojaDropdown/BojaDropdown'
import PanelListSection from '../../pages/paneli/components/PanelListSection'

import {updateLokacijaRolneRepromaterijala, updateSkladisteRepromaterijala} from '../../api'
import notifyToast from '../Toast/Toast'
import StatusComponent from './StatusComponent'
import GarancijaRepromaterijalaDropdown from '../GarancijaRepromaterijalaDropdown/GarancijaRepromaterijalaDropdown'
import PovrsinskaStrukturaDropdown from '../PovrsinskaStrukturaDropdown/PovrsinskaStrukturaDropdown'
import UlazRepromaterijalaDropdown from '../UlazRepromaterijalaDropdown/UlazRepromaterijalaDropdown'
import {updateUlazRepromaterijala} from '../../api/ulaziRepromaterijals'

const initialValues = {
  ReprMatMaterijal: undefined,
  ReprMatKvalitet: undefined,
  ReprMatProizvodjac: undefined,
  ReprMatDobavljac: undefined,
  ReprMatKodBoje: undefined,
  ReprMatSkladiste: undefined,
  ReprMatKategorija: undefined,
  ReprMatStatus: undefined,
  ReprMatLokacija: undefined,
  ReprMatBojaLica: undefined,
  ReprMatId: undefined,
  ReprMatDebljina: undefined,
  ReprMatSirina: undefined,
  ReprMatGarancija: undefined,
  ReprMatLicePovStruktura: undefined,
}
const GetFilterRepromaterijala = ({getValues, rowSelection, updatePage, filterLoading}) => {
  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: (values) => {
      getValues(values)
    },
  })

  const [skladiste, setSkladiste] = useState()
  const [ulaz, setUlaz] = useState()
  const [lokacija, setLokacija] = useState()
  const [lokacija2, setLokacija2] = useState<string>()
  const [loading, setLoading] = useState(false)

  const onClickSkladisteUpdate = () => {
    setLoading(true)
    const idList = rowSelection.map((item) => item.ReprMatId)
    const params = {
      stavkaId: idList,
      skladiste: skladiste,
    }

    updateSkladisteRepromaterijala(params)
      .then((response) => {
        notifyToast(true, response.message)
        updatePage()
      })
      .catch((error) => notifyToast(false, error.response.data.message))
      .finally(() => setLoading(false))
  }

  const onClickUlazUpdate = () => {
    setLoading(true)
    const idList = rowSelection.map((item) => item.ReprMatId)

    console.log(idList)
    //const idList = rowSelection.map((item) => item.original.ReprMatId)
    const params = {
      stavkaId: idList,
      ulaz: ulaz,
    }

    updateUlazRepromaterijala(params)
      .then((response) => {
        notifyToast(true, response.message)
        updatePage()
      })
      .catch((error) => notifyToast(false, error.response.data.message))
      .finally(() => setLoading(false))
  }
  const onClickLokacijaeUpdate = () => {
    setLoading(true)
    const idList = rowSelection.map((item) => item.ReprMatId)
    const params = {
      stavkaId: idList,
      lokacija: lokacija,
      red: lokacija2,
    }

    updateLokacijaRolneRepromaterijala(params)
      .then((response) => {
        notifyToast(true, response.message)
        updatePage()
      })
      .catch((error) => notifyToast(false, error.response.data.message))
      .finally(() => setLoading(false))
  }

  const filledCount = Object.values(formik.values).filter(
    (value) => value !== undefined && value !== null && value !== ''
  ).length

  return (
    <div>
      <PanelListSection
        title='Izmjena'
        icon='bi-pencil-square'
        description='Izmjene se primjenjuju na označene rolne u tabeli.'
        badge={<span className='badge badge-light-primary'>Odabrano: {rowSelection.length}</span>}
      >
        <div className='d-flex align-items-center gap-3 bg-light-primary rounded p-4 mb-5'>
          <i className='bi bi-info-circle text-primary fs-3' aria-hidden='true' />
          <span className='text-gray-700 fs-7'>
            {rowSelection.length
              ? 'Odaberite nove vrijednosti i potvrdite željenu izmjenu.'
              : 'Označite rolne u tabeli kako biste omogućili izmjene.'}
          </span>
        </div>
        <div className='row g-5'>
          <div className='col-12 col-lg-6 col-xl-4'>
            <div className='border rounded p-5 h-100 d-flex flex-column'>
              <h3 className='fs-5 mb-2'>Ulaz repromaterijala</h3>
              <p className='text-muted fs-7 mb-4'>Povežite odabrane rolne s ulazom.</p>
              <div role='group' aria-label='Novi ulaz' className='mb-4'>
                <div className='form-label fw-semibold'>Ulaz</div>
                <UlazRepromaterijalaDropdown
                  value={ulaz}
                  onChange={(name, value) => setUlaz(value)}
                  selectName='ulaz'
                />
              </div>
              <button
                type='button'
                className='btn btn-light-primary w-100 mt-auto'
                onClick={onClickUlazUpdate}
                disabled={!rowSelection.length || !ulaz || loading}
              >
                <i className='bi bi-check2 fs-4' aria-hidden='true' />
                Potvrdi
              </button>
            </div>
          </div>
          <div className='col-12 col-lg-6 col-xl-4'>
            <div className='border rounded p-5 h-100 d-flex flex-column'>
              <h3 className='fs-5 mb-2'>Skladište</h3>
              <p className='text-muted fs-7 mb-4'>Promijenite skladište odabranih rolni.</p>
              <div role='group' aria-label='Novo skladište' className='mb-4'>
                <div className='form-label fw-semibold'>Skladište</div>
                <SkladisteRepromaterijalaDropdown
                  value={skladiste}
                  onChange={(name, value) => setSkladiste(value)}
                  selectName='Skladiste'
                />
              </div>
              <button
                type='button'
                className='btn btn-light-primary w-100 mt-auto'
                onClick={onClickSkladisteUpdate}
                disabled={!rowSelection.length || !skladiste || loading}
              >
                <i className='bi bi-check2 fs-4' aria-hidden='true' />
                Potvrdi
              </button>
            </div>
          </div>
          <div className='col-12 col-xl-4'>
            <div className='border rounded p-5 h-100 d-flex flex-column'>
              <h3 className='fs-5 mb-2'>Lokacija i red</h3>
              <p className='text-muted fs-7 mb-4'>Odredite mjesto odabranih rolni.</p>
              <div className='row g-3 mb-4'>
                <div className='col-12 col-sm-8' role='group' aria-label='Nova lokacija'>
                  <div className='form-label fw-semibold'>Lokacija</div>
                  <LokacijeRepromaterijalaDropdown
                    value={lokacija}
                    onChange={(name, value) => setLokacija(value)}
                    selectName='Lokacija'
                  />
                </div>
                <div className='col-12 col-sm-4'>
                  <label htmlFor='reprmat-edit-red' className='form-label fw-semibold'>
                    Red
                  </label>
                  <select
                    id='reprmat-edit-red'
                    onChange={(e) => setLokacija2(e.target.value)}
                    className='form-select form-select-lg form-select-solid'
                  >
                    <option value=''>Odaberi</option>
                    <option value='1'>1</option>
                    <option value='2'>2</option>
                    <option value='3'>3</option>
                  </select>
                </div>
              </div>
              <button
                type='button'
                className='btn btn-light-primary w-100 mt-auto'
                onClick={onClickLokacijaeUpdate}
                disabled={!rowSelection.length || !lokacija || !lokacija2 || loading}
              >
                <i className='bi bi-check2 fs-4' aria-hidden='true' />
                Potvrdi
              </button>
            </div>
          </div>
          <div className='col-12'>
            <div className='border rounded p-5'>
              <h3 className='fs-5 mb-2'>Status i rezervacija</h3>
              <p className='text-muted fs-7 mb-4'>
                Promijenite status rolni i unesite podatke rezervacije kada je potrebno.
              </p>
              <StatusComponent rowSelection={rowSelection} updatePage={updatePage} redesigned />
            </div>
          </div>
        </div>
      </PanelListSection>
      <PanelListSection
        title='Filteri tabele'
        icon='bi-funnel'
        description='Odaberite kriterije, zatim primijenite filtere za pregled rolni.'
        badge={<span className='badge badge-light-primary'>Popunjeno: {filledCount}</span>}
      >
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='row g-5'>
            <div
              className='col-12 col-md-6 col-xl-4'
              role='group'
              aria-labelledby='filter-ReprMatSirina-label'
            >
              <label
                id='filter-ReprMatSirina-label'
                htmlFor='filter-ReprMatSirina'
                className='form-label fw-semibold'
              >
                Širina
              </label>
              <input
                id='filter-ReprMatSirina'
                type='text'
                placeholder='Širina'
                {...formik.getFieldProps('ReprMatSirina')}
                className='form-control form-control-lg form-control-solid'
              />
            </div>
            <div
              className='col-12 col-md-6 col-xl-4'
              role='group'
              aria-labelledby='filter-ReprMatDebljina-label'
            >
              <label
                id='filter-ReprMatDebljina-label'
                htmlFor='filter-ReprMatDebljina'
                className='form-label fw-semibold'
              >
                Debljina
              </label>
              <input
                id='filter-ReprMatDebljina'
                type='text'
                placeholder='Debljina'
                {...formik.getFieldProps('ReprMatDebljina')}
                className='form-control form-control-lg form-control-solid'
              />
            </div>
            <div
              className='col-12 col-md-6 col-xl-4'
              role='group'
              aria-labelledby='filter-ReprMatId-label'
            >
              <label
                id='filter-ReprMatId-label'
                htmlFor='filter-ReprMatId'
                className='form-label fw-semibold'
              >
                Broj rolne
              </label>
              <input
                id='filter-ReprMatId'
                type='text'
                placeholder='Broj rolne'
                {...formik.getFieldProps('ReprMatId')}
                className='form-control form-control-lg form-control-solid'
              />
            </div>
            <div
              className='col-12 col-md-6 col-xl-4'
              role='group'
              aria-labelledby='filter-ReprMatKategorija-label'
            >
              <div id='filter-ReprMatKategorija-label' className='form-label fw-semibold'>
                Kategorija
              </div>
              <KategorijaRepromaterijalaDropdown
                value={formik.values.ReprMatKategorija}
                onChange={(name, value) => formik.setFieldValue('ReprMatKategorija', value)}
                selectName='ReprMatKategorija'
              />
            </div>
            <div
              className='col-12 col-md-6 col-xl-4'
              role='group'
              aria-labelledby='filter-ReprMatKodBoje-label'
            >
              <div id='filter-ReprMatKodBoje-label' className='form-label fw-semibold'>
                Kod boje
              </div>
              <KodBojeRepromaterijalaDropdown
                value={formik.values.ReprMatKodBoje}
                onChange={(name, value) => formik.setFieldValue('ReprMatKodBoje', value)}
                selectName='ReprMatKodBoje'
              />
            </div>
            <div
              className='col-12 col-md-6 col-xl-4'
              role='group'
              aria-labelledby='filter-ReprMatMaterijal-label'
            >
              <div id='filter-ReprMatMaterijal-label' className='form-label fw-semibold'>
                Vrsta materijala
              </div>
              <VrstaMaterijalaDropdown
                value={formik.values.ReprMatMaterijal}
                onChange={(name, value) => formik.setFieldValue('ReprMatMaterijal', value)}
                selectName='ReprMatMaterijal'
              />
            </div>
            <div
              className='col-12 col-md-6 col-xl-4'
              role='group'
              aria-labelledby='filter-ReprMatKvalitet-label'
            >
              <div id='filter-ReprMatKvalitet-label' className='form-label fw-semibold'>
                Kvalitet materijala
              </div>
              <KvalitetMaterijalaDropdown
                value={formik.values.ReprMatKvalitet}
                onChange={(name, value) => formik.setFieldValue('ReprMatKvalitet', value)}
                selectName='ReprMatKvalitet'
              />
            </div>
            <div
              className='col-12 col-md-6 col-xl-4'
              role='group'
              aria-labelledby='filter-ReprMatProizvodjac-label'
            >
              <div id='filter-ReprMatProizvodjac-label' className='form-label fw-semibold'>
                Proizvođač
              </div>
              <ProizvodjacPartnerDropdown
                value={formik.values.ReprMatProizvodjac}
                onChange={(name, value) => formik.setFieldValue('ReprMatProizvodjac', value)}
                selectName='ReprMatProizvodjac'
              />
            </div>
            <div
              className='col-12 col-md-6 col-xl-4'
              role='group'
              aria-labelledby='filter-ReprMatDobavljac-label'
            >
              <div id='filter-ReprMatDobavljac-label' className='form-label fw-semibold'>
                Dobavljač
              </div>
              <DobavljacPartnerDropdown
                value={formik.values.ReprMatDobavljac}
                onChange={(name, value) => formik.setFieldValue('ReprMatDobavljac', value)}
                selectName='ReprMatDobavljac'
              />
            </div>
            <div
              className='col-12 col-md-6 col-xl-4'
              role='group'
              aria-labelledby='filter-ReprMatStatus-label'
            >
              <div id='filter-ReprMatStatus-label' className='form-label fw-semibold'>
                Status rolne
              </div>
              <StatusRolneDropdown
                value={formik.values.ReprMatStatus}
                onChange={(name, value) => formik.setFieldValue('ReprMatStatus', value)}
                selectName='ReprMatStatus'
              />
            </div>
            <div
              className='col-12 col-md-6 col-xl-4'
              role='group'
              aria-labelledby='filter-ReprMatSkladiste-label'
            >
              <div id='filter-ReprMatSkladiste-label' className='form-label fw-semibold'>
                Skladište
              </div>
              <SkladisteRepromaterijalaDropdown
                value={formik.values.ReprMatSkladiste}
                onChange={(name, value) => formik.setFieldValue('ReprMatSkladiste', value)}
                selectName='ReprMatSkladiste'
              />
            </div>
            <div
              className='col-12 col-md-6 col-xl-4'
              role='group'
              aria-labelledby='filter-ReprMatLokacija-label'
            >
              <div id='filter-ReprMatLokacija-label' className='form-label fw-semibold'>
                Lokacija
              </div>
              <LokacijeRepromaterijalaDropdown
                value={formik.values.ReprMatLokacija}
                onChange={(name, value) => formik.setFieldValue('ReprMatLokacija', value)}
                selectName='ReprMatLokacija'
              />
            </div>
            <div
              className='col-12 col-md-6 col-xl-4'
              role='group'
              aria-labelledby='filter-ReprMatBojaLica-label'
            >
              <div id='filter-ReprMatBojaLica-label' className='form-label fw-semibold'>
                Boja lica
              </div>
              <BojaDropdown
                value={formik.values.ReprMatBojaLica}
                onChange={(name, value) => formik.setFieldValue('ReprMatBojaLica', value)}
                selectName='ReprMatBojaLica'
              />
            </div>
            <div
              className='col-12 col-md-6 col-xl-4'
              role='group'
              aria-labelledby='filter-ReprMatGarancija-label'
            >
              <div id='filter-ReprMatGarancija-label' className='form-label fw-semibold'>
                Garancija
              </div>
              <GarancijaRepromaterijalaDropdown
                value={formik.values.ReprMatGarancija}
                onChange={(name, value) => formik.setFieldValue('ReprMatGarancija', value)}
                selectName='ReprMatGarancija'
              />
            </div>
            <div
              className='col-12 col-md-6 col-xl-4'
              role='group'
              aria-labelledby='filter-ReprMatLicePovStruktura-label'
            >
              <div id='filter-ReprMatLicePovStruktura-label' className='form-label fw-semibold'>
                Površinska struktura
              </div>
              <PovrsinskaStrukturaDropdown
                value={formik.values.ReprMatLicePovStruktura}
                onChange={(name, value) => formik.setFieldValue('ReprMatLicePovStruktura', value)}
                selectName='ReprMatLicePovStruktura'
              />
            </div>
          </div>
          <div className='border-top mt-6 pt-5 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-4'>
            <span className='text-muted fs-7'>Filteri se primjenjuju klikom na dugme.</span>
            <button type='submit' className='btn btn-primary' disabled={filterLoading}>
              {filterLoading ? (
                <>
                  <span className='spinner-border spinner-border-sm me-2' aria-hidden='true' />
                  Učitavanje…
                </>
              ) : (
                <>
                  <i className='bi bi-funnel fs-4' aria-hidden='true' />
                  Potvrdi
                </>
              )}
            </button>
          </div>
        </form>
      </PanelListSection>
    </div>
  )
}

export default GetFilterRepromaterijala
